import { useMultiStepModal } from '@frontend/payments-multistep-modal';
import { RegisterTerminalModalJustifiSteps, RegisterTerminalModalStripeSteps } from '../../hooks';
import { StepperProps } from '../../types';
import { STRIPE_S710_REGISTER_TERMINAL_STEPS_TITLES } from '../../utils';
import { SetupTerminal, ConnectWifi, RegisterTerminal } from './steps-components';

type AllStepsProps = {
  goToBigBang?: () => void; // handler that takes you to the start of the flow from where this flow starts
  goToStep?: (step: RegisterTerminalModalStripeSteps | RegisterTerminalModalJustifiSteps) => void; // handler that takes you to the step in the flow
  goBack?: () => void; // handler that takes you back to the previous step
  onComplete: () => void; // handler that takes you to the next step in the flow
  onRegisterTerminal: () => void; // handler that takes you to the next step in the flow
  Stepper: React.FC<StepperProps>; // component that renders the stepper
  locationId?: string;
  stripeLocationId?: string;
};

export const AllSteps = ({
  goToBigBang,
  goToStep,
  goBack,
  onComplete,
  onRegisterTerminal,
  Stepper,
  locationId,
  stripeLocationId,
}: AllStepsProps) => {
  const { setHideStepper } = useMultiStepModal();

  return (
    <>
      <Stepper
        components={{ Footer: () => null }}
        label={STRIPE_S710_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalStripeSteps.SetupTerminal].heading}
        id={RegisterTerminalModalStripeSteps.SetupTerminal}
      >
        <SetupTerminal goBack={goToBigBang} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={STRIPE_S710_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalStripeSteps.ConnectWifi].heading}
        id={RegisterTerminalModalStripeSteps.ConnectWifi}
        parentId={RegisterTerminalModalStripeSteps.SetupTerminal}
      >
        <ConnectWifi goBack={goBack} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={STRIPE_S710_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalStripeSteps.RegisterTerminal].heading}
        id={RegisterTerminalModalStripeSteps.RegisterTerminal}
        parentId={RegisterTerminalModalStripeSteps.ConnectWifi}
      >
        <RegisterTerminal
          goBack={goBack}
          goToStep={goToStep}
          onSuccess={onComplete}
          onTerminalPaired={onRegisterTerminal}
          onStatusScreenChange={setHideStepper}
          locationId={locationId}
          stripeLocationId={stripeLocationId}
        />
      </Stepper>
    </>
  );
};

AllSteps.displayName = 'RegisterTerminalStripeStep';
